import { render, staticRenderFns } from "./invoice-add.vue?vue&type=template&id=3f5ca8e0&scoped=true&"
import script from "./invoice-add.vue?vue&type=script&lang=js&"
export * from "./invoice-add.vue?vue&type=script&lang=js&"
import style0 from "./invoice-add.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./invoice-add.vue?vue&type=style&index=1&id=3f5ca8e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5ca8e0",
  null
  
)

export default component.exports